// Tiny i18n helper for front-end strings.
//
// WordPress localizes user-facing JS copy into `AP_DATA.i18n` (see
// autoplaza_js_i18n() in inc/enqueue.php). Those values are translated RO⇄RU
// through the normal .po pipeline. `t()` looks a string up by its snake_case
// KEY and falls back to a supplied Romanian literal when the key is missing, so
// the UI never renders blank if a translation is absent.
//
//   t('save_search', 'Salvează căutarea')
//
// For strings with placeholders, expose the template via t() and interpolate
// with sprintf(): sprintf(t('photos_in_listing', '%d fotografii în anunț'), n).

const I18N = (typeof window !== 'undefined' && window.AP_DATA && window.AP_DATA.i18n)
  ? window.AP_DATA.i18n
  : {};

export function t(key, fallback) {
  const v = I18N[key];
  return (typeof v === 'string' && v.length) ? v : (fallback != null ? fallback : key);
}

// Minimal printf-style interpolation. Supports positional %s / %d in order of
// appearance - enough for the theme's templated strings.
export function sprintf(template, ...args) {
  let i = 0;
  return String(template).replace(/%[sd]/g, () => {
    const a = args[i++];
    return a == null ? '' : String(a);
  });
}
